<template>
      <v-card>
        <v-card-title>
          <span class="headline">Membership Benefit of 91 Running Camp</span>
        </v-card-title>
        <v-card-text font-weight-medium>
          <p class="text-left">
          The membership benefits are listed as below:
          </p><p class="text-left">
Common Service
<ul><li class="text-left">Organized group running regularly (weekly during the training term)
</li><li class="text-left">Water and Supply station for group running
</li><li class="text-left">Lead runner for group running, Lactate Treadhold Running etc
</li><li class="text-left">Car pool coordination
</li><li class="text-left">Workshops for running knowledge and techniques (Nutrition, Drills, Runnings, Strength training, injury recovery etc）
</li><li class="text-left">Access to experienced runners with first-hand knowledge of marathonsand running techniques
</li></ul>
</p><p class="text-left">
Mentoring Service
<ul><li class="text-left">
Running clinics and running techniques mentoring
</li></ul>
</p><p class="text-left">
Coaching Service  (Eligible for Race Training Group)
<ul><li class="text-left">Customized training plan
</li><li class="text-left">Training performance regular review and follow-up
</li><li class="text-left">Lead running
</li></ul>
</p><p class="text-left">
Marathon Events Support ( "A" goal) ((Eligible for Race Training Group)
<ul><li class="text-left">Pre-events workshop: course introdution, running strategy, preparation
</li><li class="text-left">Events support: Advance supply, cheer station, Car pool
</li><li class="text-left">Post-events: Recover plan
</li></ul>
</p><p class="text-left">
Commercial partner
<ul><li class="text-left">15% discount on all regular price products purchase at the Running Free shop
</li><li class="text-left">10% discount at Grace Mountain Ginseng shop
</li><li class="text-left">Promotion codes on the Major Running Events in Toronto/Ontario
  </li></ul>
</p><p class="text-left">
Others
<ul><li class="text-left">Camp Social events
</li><li class="text-left">Charity events
</li></ul>
          </p>
        </v-card-text>
      </v-card>
</template>

<script>
export default {
  data () {
    return {
      IAgree: '',
      error: null
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Users/MembershipBenefit.vue